import Vue from 'vue'
import certificates from './index.vue'
Vue.component('select-certificates', certificates);